import { render, staticRenderFns } from "./AdminQRcodeSetting.vue?vue&type=template&id=126b682e&scoped=true&"
import script from "./AdminQRcodeSetting.vue?vue&type=script&lang=js&"
export * from "./AdminQRcodeSetting.vue?vue&type=script&lang=js&"
import style0 from "./AdminQRcodeSetting.vue?vue&type=style&index=0&id=126b682e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126b682e",
  null
  
)

export default component.exports